import React from 'react';
import { fireOtpSubmitted, fireSignUpSuccess, fireSocialAuthFailed } from '~/analytics/auth';
import useAnonymousId from '~/analytics/useAnonymousId';
import { AnalyticsEvent } from '~/types/AnalyticsEvent';

export default function useAnalyticsEvents({ analyticsEvents }: { analyticsEvents: AnalyticsEvent[] }) {
  const anonymousId = useAnonymousId();
  React.useEffect(() => {
    if (anonymousId && analyticsEvents?.length)
      analyticsEvents.forEach((event) => {
        switch (event.type) {
          case 'fireSignUpSuccess':
            fireSignUpSuccess({ anonymousId, method: event.method, email: event.email, userId: event.userId });
            break;
          case 'fireSocialAuthFailed':
            fireSocialAuthFailed({ anonymousId, provider: event.provider });
            break;
          case 'fireOtpSubmitted':
            fireOtpSubmitted({ anonymousId, email: event.email, valid: true });
            break;
          default:
            console.warn('Unknown analytics event:', event);
        }
      });
  }, [anonymousId, analyticsEvents]);
}
